import { Button, Col, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import "./style.scss";

const ModalConfirm = ({
  onOk = () => {},
  onCancel = () => {},
  onOkText = "",
  onCancelText = "",
  onOkColor,
  onCancelColor,
  open,
  title = "",
  content,
}) => {
  const footer = () => (
    <div className="modal-confirm-footer">
      <Button style={{ color: onCancelColor }} onClick={onCancel}>
        {onCancelText}
      </Button>
      <Button style={{ color: onOkColor }} onClick={onOk}>
        {onOkText}
      </Button>
    </div>
  );

  return (
    <Modal
      className="modal-confirm-container"
      open={open}
      title={title}
      onOk={onOk}
      onCancel={onCancel}
      footer={footer}
      closable={true}
      centered
    >
      {content}
    </Modal>
  );
};

export default ModalConfirm;
